var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "downloadThread" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("language.popup.downloadThreadPopup.title")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePage()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "download-thread-content" }, [
            _c("div", { staticClass: "download-thread-title" }, [
              _vm._v(_vm._s(_vm.$t("language.popup.downloadThreadPopup.tips")))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name"
                  }
                ],
                attrs: {
                  id: "zipName",
                  placeholder: _vm.defaultName,
                  onfocus: "this.placeholder=''",
                  onblur: "this.placeholder='" + _vm.defaultName + "'",
                  maxlength: "255"
                },
                domProps: { value: _vm.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.name = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "download-thread-options" }, [
              _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                _c("div", {
                  staticClass: "icon-util",
                  class: _vm.isSave ? "check-small" : "nocheck-small-blue",
                  on: {
                    click: function($event) {
                      _vm.isSave = !_vm.isSave
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.downloadThreadPopup.option1"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { position: "relative", "margin-bottom": "8px" }
                },
                [
                  _c("div", {
                    staticClass: "icon-util",
                    class: _vm.isCoversation
                      ? "check-small"
                      : "nocheck-small-blue",
                    on: {
                      click: function($event) {
                        _vm.isCoversation = !_vm.isCoversation
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.popup.downloadThreadPopup.option2")
                      ) + "\n                        "
                    ),
                    _c("div", { staticClass: "icon-util question-mark" }, [
                      _c("div", { staticClass: "plan-questionTxt" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "language.popup.downloadThreadPopup.option2Tips"
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { position: "relative", "margin-bottom": "8px" }
                },
                [
                  _c("div", {
                    staticClass: "icon-util",
                    class: _vm.isSaveLast
                      ? "check-small"
                      : "nocheck-small-blue",
                    on: {
                      click: function($event) {
                        _vm.isSaveLast = !_vm.isSaveLast
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.popup.downloadThreadPopup.option3")
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _c("div", {
                  staticClass: "icon-util",
                  class: _vm.delWatermark
                    ? "check-small"
                    : "nocheck-small-blue",
                  on: {
                    click: function($event) {
                      _vm.delWatermark = !_vm.delWatermark
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { float: "left" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.paySystem.freePlanPopup.itemTitle_watermark"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "icon-util vip",
                  staticStyle: { float: "left", margin: "0 5px" }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "download-thread-footer" }, [
            !_vm.loading
              ? _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.download()
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("language.common.ok")))])]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loading
              ? _c("button", [
                  _c("span", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ]
                  })
                ])
              : _vm._e()
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e255cce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e255cce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/email_exploer_popups/download_thread_popup.vue
// module id = null
// module chunks = 